import { removeTokenInLocalStorage } from '../storage/token';
import { KStadiumDefaultRes } from '../apis/kstadiumAPI/types';

export const logout = () => removeTokenInLocalStorage();

export const isKStadiumServerErrorRes = (
  res: any,
): res is KStadiumDefaultRes => {
  return res?.statusCode;
};
